import * as React from "react";
import { useTranslation } from "react-i18next";

import styles from "./StressResistance.module.scss";

import { stressResistanceHead, stressResistanceMan } from "assets/image";

const StressResistance = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className={styles.mainWrapper}>
      <div className={styles.title}>
        <img
          className={styles.titleImage}
          src={stressResistanceHead}
          alt="Head"
        />
        {t("Docs.StressResistance.Title")}
      </div>
      <div className={styles.blockContainer}>
        <div className={styles.column}>
          <div className={styles.text}>
            <span className={styles.text_blue}>
              {t("Docs.StressResistance.Blocks.Block1.TextBlue")}
            </span>
            {t("Docs.StressResistance.Blocks.Block1.Text")}
          </div>
          <div className={styles.text}>
            {t("Docs.StressResistance.Blocks.Block2.Text")}
            <span className={styles.text_blue}>
              {t("Docs.StressResistance.Blocks.Block2.TextBlue")}
            </span>
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.text}>
            <span className={styles.text_blue}>
              {t("Docs.StressResistance.Blocks.Block3.TextBlue")}
            </span>
            {t("Docs.StressResistance.Blocks.Block3.Text")}
          </div>
          <div className={styles.text}>
            <span className={styles.text_blue}>
              {t("Docs.StressResistance.Blocks.Block4.TextBlue")}
            </span>
            {t("Docs.StressResistance.Blocks.Block4.Text")}
          </div>
          <div className={styles.text}>
            <span className={styles.text_blue}>
              {t("Docs.StressResistance.Blocks.Block5.TextBlue")}
            </span>
            {t("Docs.StressResistance.Blocks.Block5.Text")}
          </div>
        </div>
      </div>
      <div className={styles.imageContainer}>
        <img className={styles.image} src={stressResistanceMan} alt="sad man" />
      </div>
    </div>
  );
};

export default StressResistance;
